import request from '@/service/chat'
import qs from 'qs'

export const getSubUserList = (params: any) => {
  return request({
    url: '/agent/getSubUserList',
    method: 'GET',
    params
  })
}

// 获取下级用户消费明细
export const GetSubFundsList = (params: any) => {
  return request({
    url: '/referrals/GetTaskList',
    method: 'GET',
    params
  })
}
// 获取结算列表
export const GetSettlementList = (params: any) => {
  return request({
    url: '/referrals/GetList',
    method: 'GET',
    params
  })
}

// 获取结算统计概览
export const GetOverview = () => {
  return request({
    url: '/referrals/GetOverview',
    method: 'GET'
  })
}

// 结算佣金
export const SaveSettel = (data: any) => {
  return request({
    url: '/referrals/SaveSettel',
    method: 'POST',
    data: qs.stringify(data)
  })
}